// Mock data for Frauenarztpraxis Dr. med. Christina Weiß

export const practiceInfo = {
  name: "Frauenarztpraxis Dr. med. Christina Weiß",
  doctor: "Dr. med. Christina Weiß",
  specialty: "Fachärztin für Gynäkologie und Geburtshilfe seit 1999",
  since: "2006",
  owner_since: "1. Januar 2020",
  address: {
    street: "Blanke Str. 17",
    city: "31028 Gronau (Leine)",
    country: "Deutschland"
  },
  contact: {
    phone: "05182-1212",
    email: "terminanfrage@frauenarzt-praxis-gronau.de",
    booking_url: "https://app.arzt-direkt.de/frauenarzt-praxis-gronau/booking"
  },
  description: "Die Frauenarztpraxis in Gronau besteht bereits seit 1988 und wurde damals von Dr. med. Wilfried Lüdemann gegründet. Dr. med. Christina Weiß ist 2006 in die Praxis eingestiegen. Seit 2020 führt sie die Praxis als alleinige Inhaberin weiter."
};

export const openingHours = {
  monday: { morning: "08:30–12:00", afternoon: "13:00–16:00" },
  tuesday: { morning: "08:30–12:00", afternoon: "13:00–16:00" },
  wednesday: { morning: "geschlossen", afternoon: "14:00–18:00" },
  thursday: { morning: "08:30–12:00", afternoon: "15:00–18:00" },
  friday: { morning: "08:30–13:00", afternoon: "geschlossen" },
  emergency: "Montag–Freitag 08:30–09:30, Mittwoch 14:00–15:00"
};

export const services = [
  {
    id: 1,
    title: "Vorsorgeuntersuchungen",
    description: "Regelmäßige gynäkologische Vorsorge und Krebsfrüherkennung für Ihre Gesundheit.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Schwangerschaftsbetreuung",
    description: "Umfassende Betreuung während der Schwangerschaft mit modernster Diagnostik.",
    icon: "Baby"
  },
  {
    id: 3,
    title: "Verhütungsberatung",
    description: "Individuelle Beratung zu verschiedenen Verhütungsmethoden und deren Anwendung.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Ultraschalldiagnostik",
    description: "Moderne Ultraschalluntersuchungen für präzise Diagnosen und Verlaufskontrollen.",
    icon: "Activity"
  },
  {
    id: 5,
    title: "Hormonberatung",
    description: "Beratung und Behandlung bei Hormonstörungen und Wechseljahrsbeschwerden.",
    icon: "Zap"
  },
  {
    id: 6,
    title: "IGeL-Leistungen",
    description: "Zusätzliche Gesundheitsleistungen für erweiterte Vorsorge und Diagnostik.",
    icon: "Plus"
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Dr. med. Christina Weiß",
    role: "Inhaberin und Gynäkologin",
    description: "Fachärztin für Gynäkologie und Geburtshilfe, in der Praxis seit 2006, Inhaberin seit 1. Januar 2020.",
    experience: "Seit 2006",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/9o7nffs5_Dr.%20med.%20Christina%20Wei%C3%9F.JPG"
  },
  {
    id: 2,
    name: "Daniela Gerke",
    role: "Medizinische Fachangestellte, Teamleiterin",
    description: "Teamleiterin seit 1988 mit umfangreicher Erfahrung in der gynäkologischen Betreuung.",
    experience: "Seit 1988",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/aemtugv5_Daniela%20Gerke.JPG"
  },
  {
    id: 3,
    name: "Elvira Nazarenus",
    role: "Medizinische Fachangestellte",
    description: "Assistentin seit 2005 mit Schwerpunkt auf Patientenbetreuung und Diagnostik.",
    experience: "Seit 2005",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/n12wzqgb_Elvira%20Nazarenus.JPG"
  },
  {
    id: 4,
    name: "Doris Leszczak",
    role: "Medizinische Fachangestellte",
    description: "Seit 2008 zuständig für IGeL-Beratung und Laborvorbereitung.",
    experience: "Seit 2008",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/ureezqu0_Doris%20Leszczak.JPG"
  },
  {
    id: 5,
    name: "Nadja Poljakow",
    role: "Medizinische Fachangestellte",
    description: "Assistentin seit 2023, unterstützt das Team in der täglichen Patientenversorgung.",
    experience: "Seit 2023",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/1we6ieyn_Nadja%20Poljakow.png"
  },
  {
    id: 6,
    name: "Marion Kirchhoff",
    role: "Medizinische Fachangestellte",
    description: "Seit 2023 verantwortlich für Patientenkommunikation und Terminkoordination.",
    experience: "Seit 2023",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/0ih1yoz9_Marion%20Kirchhoff.png"
  },
  {
    id: 7,
    name: "Ivana Grnchavov",
    role: "Medizinische Fachangestellte",
    description: "Assistenz bei Untersuchungen und Laborunterstützung.",
    experience: "Seit 2022",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/3ori7nrx_Ivana%20Grnchavov.png"
  }
];

export const practiceImages = [
  {
    id: 1,
    title: "Empfangsbereich",
    description: "Unser freundlicher Empfangsbereich heißt Sie willkommen",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/ojprk51s_reception%20area.JPG"
  },
  {
    id: 2,
    title: "Sprechzimmer",
    description: "Moderne Ausstattung für ausführliche Beratungsgespräche",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/jitb3xko_cosultation%20room.JPG"
  },
  {
    id: 3,
    title: "Behandlungsraum",
    description: "Professionelle Behandlungsräume mit modernster medizinischer Technik",
    image: "https://customer-assets.emergentagent.com/job_frauenarzt-gronau/artifacts/4xn83apg_treatment%20room.JPG"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Heike Kierse",
    text: "Ich finde diese Praxis einfach toll. Von dem ganzen Team und auch Frau Doktor Weiß bin ich sehr freundlich und gut behandelt worden. Ich musste dringend zu einer Untersuchung, die nicht warten konnte – mir wurde sofort angeboten, in die Notfallsprechstunde zu kommen, weil ich bei anderen Ärzten abgewiesen wurde. Frau Weiß war die einzige Ärztin, die der Sache umgehend auf den Grund gegangen ist und mir direkt Lösungen erklärt hat, damit mir schnell geholfen wird. Ich kann das komplette Team und Frau Weiß nur loben und empfehlen. Ich bin dankbar, dass ich als neue Patientin künftig dort bleiben kann.",
    rating: 5,
    date: "vor 7 Monaten",
    isGoogleReview: true
  },
  {
    id: 2,
    name: "Renate Gruber",
    text: "Ich muss sagen … das Team ist super freundlich und hilfsbereit. Frau Doktor Weiß hört mir zu. Habe noch einen Termin bekommen, damit man Gewissheit hat. Vielen lieben Dank.",
    rating: 5,
    date: "vor 2 Monaten",
    isGoogleReview: true
  },
  {
    id: 3,
    name: "Catin Ka",
    text: "Frau Dr. Weiß betreut mich mittlerweile seit mehreren Schwangerschaften und hat mich auch durch Fehlgeburten begleitet. Die Betreuung ist immer herzlich und zuvorkommend, sowohl von Frau Dr. Weiß als auch vom Team. Die Wartezeiten sind auch völlig im Rahmen.",
    rating: 5,
    date: "vor 7 Monaten",
    isGoogleReview: true
  }
];